import React from "react";
import PropTypes from 'prop-types'
import clsx from "clsx";
import {makeStyles} from "@material-ui/styles";
import {primaryDropColor} from "../../ScreenBar";
const useStyles = makeStyles( {
    rowRenderDirection: {
        transition: 'width 0.3s ease',
    },
    columnRenderDirection: {
        transition: 'height 0.3s ease',
    }
});
const DropArea = ({direction, isOverCurrent, renderDirection}) => {
    const classes = useStyles();
    const styles = generateDropAreaStyles(renderDirection, direction, isOverCurrent);
    const currentClass = clsx({
        [classes.rowRenderDirection]: renderDirection === 'row',
        [classes.columnRenderDirection]: renderDirection === 'column'
    });
    return (
        <div
            className={currentClass}
            style={{
                position: 'absolute',
                background: primaryDropColor,
                ...styles
            }}
        >
        </div>
    )
};
export default DropArea
DropArea.propTypes = {
    direction: PropTypes.oneOf(['top', 'bottom', null]),
    isOverCurrent: PropTypes.bool,
    renderDirection: PropTypes.string
}

/**
 *
 * @param renderDirection <string>
 * @param direction <string>
 * @param isOverCurrent <boolean>
 * @returns {{left: (boolean|string), width: number, right: (boolean|string), height: string}|{top: (boolean|string), bottom: (boolean|string), width: string, height: number}}
 */
export function generateDropAreaStyles(renderDirection, direction, isOverCurrent) {
    if (!isOverCurrent) {
        return {
            display: 'none',
            width: 0,
            height: '0',
            top: '0',
            bottom: '0',
            left: '0',
            right: '0'
        }
    }
    if (renderDirection === 'column') {
        return {
            width: '100%',
            height: isOverCurrent ? 5 : 0,
            top: direction === 'top' && '-3px',
            bottom: direction === 'bottom' && '-4px',
        }
    }
    if (renderDirection === 'row') {
        return {
            width: isOverCurrent ? 5 : 0,
            height: isOverCurrent ? '100%' : 0,
            top: 0,
            left: direction === 'top' && '0',
            right: direction === 'bottom' && '0',
        }
    }
}